import React from 'react';
import { Button, Typography } from '@mui/material';
import { useAuth } from 'oidc-react';

export default function StatusApiError({ error, message }) {
  const auth = useAuth();

  if (error?.unauthorized) {
    return (
      <div style={{ margin: 32, textAlign: 'center' }}>
        <Typography gutterBottom>Session expired.</Typography>
        <Button variant="contained" onClick={() => auth.signIn()}>
          Sign in again
        </Button>
      </div>
    );
  }

  return (
    <Typography sx={{ m: 4 }} style={{ textAlign: 'center' }}>
      {message}
    </Typography>
  );
}
